import * as axiosService from "./axiosService";


//get service type master
export const getServicesTypeMaster = (lang = "en") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getServicesTypeMaster?lang=${lang}`
  );
};


//get mobile code by country code
export const getCountryMobileCodeMaster = (countryCode = "",isIcon=false, lang = "en") => {
  let apiUrl =
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getCountryMobileCodeMaster?lang=${lang}`;
  if (countryCode !== "") {
    apiUrl += `&country_code=${countryCode}`;

  }
  if(isIcon){
    apiUrl += `&icon=${true}`;
  }
  return axiosService.Get(apiUrl);
};


//get state master by country code
export const getStateMaster = (countryCode,module,lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getStateMaster?country_code=${countryCode}&lang=${lang}&module=${module ? module : ""}`
  );
};


//get country master
export const getCountryMaster = (lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getCountryMaster?lang=${lang}`
  );
};


//get city master
export const getCityMaster = (countryCode, stateCode,module, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getCityMaster?country_code=${countryCode}&state_code=${stateCode}&lang=${lang}&module=${module ? module : ""}`
  );
};


export const getCityMasterByCountry = (countryCode,module, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getCityMaster?country_code=${countryCode}&lang=${lang}&module=${module ? module : ""}`
  );
};

export const getCityMasterBasedOnSearch = (value, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getCityMaster?search_text_city=${value}&lang=${lang}`
  );
}


//get industry master
export const getIndustryMaster = (country,lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getIndustryMaster?lang=${lang}&country=${country}`
  );
};

//get currency master
export const getCurrencyMaster = (countryCode, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getCurrencyMaster?country_code=${countryCode}&lang=${lang}`
  );
};
export const getAllCurrencyMaster = (lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getCurrencyMaster?lang=${lang}`
  );
};

//get department master
export const getDepartmentMaster = (lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getDepartmentMaster?lang=${lang}`
  );
};


//get truck type
export const getTruckType = (type="truckType",loadingType="",lang = "EN") => {
  if(type == "truckType"){
    return axiosService.Get(
      process.env.REACT_APP_MASTER_DATA_API_URL + `/getTruckTypeMaster?lang=${lang}&type=truckType&truckImage=true&loadingType=${loadingType}`
    )
  }
}

//get sub truck type
export const getSubTruckType = (typeId,loadingType="", lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getTruckTypeMaster?type_id=${typeId}&type=subTruckType&lang=${lang}&loadingType=${loadingType}`
  )
}


export const getCityMasterByName = (lang = "EN", searchCity) => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getCityMaster?search_text_city=${searchCity}`
  )
}

//get city By Country master
export const getCityByCountryMaster = (countryCode) => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/getCityMaster?country_code=${countryCode}`
  );
};


export const getCountryWiseClassMaster = (country,lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getClassMaster?lang=${lang}&country=${country}`
  );
};


//get truck type
export const getTruckTypeForAssetPlanner = (type="API",lang = "EN") => {
  if(type == "API"){
      return Promise.resolve({data:[
        {
            "_id": "643f96b7d5a3361af5b587f2",
            "type_id": 33,
            "type": "TIR",
            "region": "TR"
        },
        {
            "_id": "643f96b7d5a3361af5b587fa",
            "type_id": 35,
            "type": "KIRKAYAK",
            "region": "TR"
        },
        {
            "_id": "643f96b7d5a3361af5b587f9",
            "type_id": 34,
            "type": "KAMYON",
            "region": "TR"
        }
    ],status:200})
  }
  else {
    return Promise.resolve({data:[{"_id":"63a55018193a0b865bf2b625","type_id":1,"type":"Pickup"},{"_id":"63a55018193a0b865bf2b62a","type_id":2,"type":"Trailer"},{"_id":"63a55018193a0b865bf2b638","type_id":3,"type":"Semi-trailer"}],status:200})
  }
}

//get sub truck type
export const getSubTruckTypeForAssetPlanner = (typeId, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getTruckTypeMaster?type_id=${typeId}&type=subTruckType&lang=${lang}`
  )
}

export const getPackagingMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getPackagingMaster`
  )
}

export const getTruckTypeClass = (Class,lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getTruckTypeMaster?lang=${lang}&type=truckType&class=${Class}`
  )
}

//get sub truck type
export const getSubTruckTypeClass = (typeId, Class, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_FIRST_API_URL + `/getTruckTypeMaster?type_id=${typeId}&type=subTruckType&class=${Class}&lang=${lang}`
  )
}

//get function teams customer care poc
export const getFunctionalTeamMaster = (country) => {
  if(country?.toLowerCase()==="egypt"){
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getFunctionalTeamMaster?region=${country}`
  )
}else{
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getFunctionalTeamMaster`
  )
}
}

export const getCustomLocationMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getCustomLocationMaster`
  )
}

export const getShippingLineMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getShippingLineMaster`
  )
}

export const getContainerMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getContainerMaster`
  )
}

export const getPortYardMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getPortYardMaster?type=port`
  )
}

export const getYardByPortId = (port_id) => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getPortYardMaster?type=yard&port_id=${port_id}`
  )
}

export const getVatPercentageMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getVatPercentageMaster`
  )
}

export const getAllTruckTypeAndSubTruckType=(loadingType,pricingUnit,country,operationType)=>{
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getAllTruckTypeAndSubTruckType?country=${country}&loadingType=${loadingType}&operationType=${operationType}&pricingUnit=${pricingUnit}`
  )
}

//get commodity master
export const getCommodityMaster = (lang) => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getCommodityMaster?lang=${lang}`
  );
};

export const getCountryStateCityMasterBasedOnSearch = (value, lang = "EN") => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +
    `/get_city_state_country_master?search_text=${value}&lang=${lang}`
  );
}

export const getBrandNameMaster= () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL +`/getTruckMakeMaster?lang=EN`
  );
}

//get Exchange rate 
export const GetTurkeyExchangeRate = (from_currency,to_currency,country)=>{
  return axiosService.Get(process.env.REACT_APP_INQUIRY_MANAGEMENT_API_URL + `/Netsuite/GetTurkeyExchangeRate?from_currency=${from_currency}&to_currency=${to_currency}&country=${country}`);
}